module.exports = __webpack_public_path__ + "static/img/icon_fb_blue.6163476.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_fb_blue.png
// module id = Lpxb
// module chunks = 1